<template>
  <div class="login-wrap">
    <div class="login-content">
      <img
        src="../assets/images/login/logo-mp.svg"
        alt="MeetPoint"
        class="login-logo"
      />
      <div class="login-title">SCAN APP</div>
      <form class="login-form" @submit.prevent="login">
        <div class="form-title">Log in with your MeetPoint account</div>
        <div class="input-group login-field">
          <input
            v-model="email"
            type="email"
            class="form-control"
            placeholder="Email address"
            aria-label="Email address"
            autocomplete="username"
            required
          />
        </div>
        <div class="input-group login-field login-field--password">
          <input
            v-model="password"
            :type="showPassword ? 'text' : 'password'"
            class="form-control"
            placeholder="Password"
            aria-label="Password"
            autocomplete="current-password"
            required
          />
          <button
            class="login-password-toggle"
            type="button"
            :aria-label="showPassword ? 'Hide password' : 'Show password'"
            @click="showPassword = !showPassword"
          >
            <img
              v-if="showPassword"
              src="../assets/images/login/icon-eye-solid.svg"
              alt=""
            />
            <img
              v-else
              src="../assets/images/login/icon-eye-slash-solid.svg"
              alt=""
            />
          </button>
        </div>
        <div v-if="errorMessage" class="form-error" role="alert">
          {{ errorMessage }}
        </div>
        <button type="submit" class="btn btn--lg btn--primary login-btn" :disabled="isSubmitting">
          {{ isSubmitting ? "Logging in..." : "Log in" }}
        </button>
      </form>
    </div>
    <footer class="login-footer">
      MP Scan app is part of the MeetPoint family of event management solutions.<br />
      Use your MeetPoint credentials to log in.
    </footer>
  </div>
</template>

<script>
export default {
  name: "LoginView",
  data: () => ({
    email: null,
    password: null,
    errorMessage: "",
    isSubmitting: false,
    showPassword: false,
  }),
  methods: {
    async login() {
      if (this.isSubmitting) return;
      this.errorMessage = "";
      this.isSubmitting = true;
      try {
        const resp = await fetch(process.env.VUE_APP_ROOT_API.replace(/\/rest$/, "") + "/v1/auth/sessions", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ username: this.email, password: this.password, clientApp: "mp-scan" }),
        });
        if (!resp.ok) {
          this.errorMessage = [401, 403].includes(resp.status)
            ? "Your username or password is incorrect."
            : "Sign-in is temporarily unavailable. Please try again.";
          return;
        }
        const response = await resp.json();
        if (!response?.token) {
          this.errorMessage = "Sign-in is temporarily unavailable. Please try again.";
          return;
        }
        this.$store.commit("setAuthToken", {
          token: { token: response.token, date: new Date() },
          name: response.name || this.email,
          lastName: response.lastName || "",
        });
        try {
          await this.$store.dispatch("loadParticipantStatuses");
        } catch (_) {
          this.$store.commit("clearSession");
          this.errorMessage = "Sign-in succeeded, but participant statuses are unavailable. Please try again.";
          return;
        }
        this.$router.push("/events");
      } catch (_) {
        this.errorMessage = "Sign-in is temporarily unavailable. Please try again.";
      } finally {
        this.isSubmitting = false;
      }
    },
  },
};
</script>
